import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

import ReactDatatable from "@ashvin27/react-datatable";

import _ from "lodash";

import { dataTableConfig } from "../../../configs/data-table.config";

import { DatasetDefault, DatasetModel } from "../../../models/dataset.model";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../../models/requestInputOutputParams.model";

import EquipmentDataService from "../../../services/equipmentData.service";
import { FileExportService } from "../../../services/fileExport.service";

import DropdownButtonExport from "../../../components/dropdownButton/export";
import storageService from "../../../services/storage.service";
import UtilService from "../../../services/util.service";
import moment from "moment";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Select from 'react-select';

import { Alert,  ButtonGroup, Col, Form, OverlayTrigger, Popover, Row, Tooltip } from "react-bootstrap";
import ButtonSearch from "../../../components/buttons/search";
import ButtonDelete from "../../../components/buttons/delete";
import { ButtonClean } from "../../../components/buttons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTrashCan, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

export const EquipmentHistoryModal = (props: any) => {
    const [numberDeleted, setNumberDeleted] = useState(0);
    const [balanceVal, setBalanceVal] = useState('0');
    const [operationVal, setOperationVal] = useState({ value: '5', label: '='  });
    const [data, setData] = useState<DatasetModel>();
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const [dataset, setDataset] = useState<DatasetModel>(
        {
            ...JSON.parse(JSON.stringify(DatasetDefault)),
            dataset: 'equipment_data',
            filters: {
                equipment_id: [props.id],
                filter_history: [props.filter_history]
            },
            sort: {
                field: 'read_date',
                orientation: 'desc'
            }
        });

    const clear = () => {
        let tDataSet: DatasetModel = ({
            ...JSON.parse(JSON.stringify(DatasetDefault)),
            dataset: 'equipment_data',
            filters: {
                equipment_id: [props.id],
                filter_history: [props.filter_history]
            },
            sort: {
                field: 'read_date',
                orientation: 'desc'
            }
        });
        setNumberDeleted(0);
        setDataset(tDataSet);
        setBalanceVal('0');
        setOperationVal({ value: '5', label: '='  });
        setStartDate(null);
        setEndDate(null);
    };

    const close = () => {
        clear();
        props.close();
    }
    
    const user = storageService.getUser();

    const columns = [
        {
            key: "totalIn",
            text: t("EQUIPMENT_HISTORY_MODAL.TOTAL_IN"),
            align: "left",
            sortable: false,
            cell: (record) => {
                return <>{UtilService.formatNumberIdioma(record.totalIn)}</>
            }
        },
        {
            key: "balance",
            text: t("EQUIPMENT_HISTORY_MODAL.BALANCE"),
            align: "left",
            sortable: false,
            cell: (record) => {
                return <>{UtilService.formatNumberIdioma(record.balance)}</>
            }
        },
        {
            key: "pickup",
            text: t("EQUIPMENT_HISTORY_MODAL.PICKUP"),
            align: "left",
            sortable: false,
            cell: (record) => {
                return <>{UtilService.formatNumberIdioma(record.pickup)}</>
            }
        },
        {
            key: "readDate",
            text: t("EQUIPMENT_HISTORY_MODAL.READ_DATE"),
            align: "left",
            sortable: false,
            cell: (record) => {
                return <>{UtilService.formatDate(moment(record.readDate),user.locale.formatDate)}</>
                // return <>{moment(record.readDate).format(user.locale.formatDate)}</>
            }
        },
        {
            key: "deletedat",
            text: t("EQUIPMENT_HISTORY_MODAL.DELETED_AT"),
            align: "left",
            sortable: false,
            cell: (record) => {
                <>
                    {record.deletedAt ? UtilService.formatDate(moment(record.deletedAt), user.locale) : null}
                </>                    
                // record.deletedAt ? moment(record.deletedAt).format(user.locale.formatDate) :''}</>
            }
        },
        {
            key: "item_delet",
            text: <FontAwesomeIcon icon={faTrashCan} className='me-2' />,
            align: "left",
            sortable: false,
            checkboxSelection: true,
            cell: (record) => {
                const yesterday = moment().subtract(1, 'days').startOf('day'); // Data de ontem (00:00:00)
                const readDate = moment(record.readDate).startOf('day'); // Data da linha, sem hora

                const isDisabled = readDate.isSame(yesterday); // Verifica se é igual a ontem

                return <>
                {record.deletedAt ?
                 <FontAwesomeIcon
                 style={{ color: "red" }}
                 icon={faTimesCircle}
                 className='mb-1'
                 onClick={async (e) => setFilterRestore(record.id)}
                 /> : 
                 <input 
                    id= {record.id } 
                    onClick={async (e) => {
                        if (!isDisabled) {
                            setFilterDelete(e.currentTarget);
                        }
                    }}
                    type="checkbox" 
                    disabled={isDisabled}
                />
                }
                </>
            }
        },

        // {
        //     key: "close_date",
        //     text: t("EQUIPMENT_HISTORY_MODAL.CLOSE_DATE"),
        //     align: "left",
        //     sortable: false
        // },
    ]

    const localDataTableConfig = {
        ...dataTableConfig,
        language: {
            filter: t(`DATA_GRID.SEARCH`),
            info: t(`DATA_GRID.INFO_START`) +
                " _START_ " + t(`DATA_GRID.INFO_TO`) +
                " _END_ " + t(`DATA_GRID.INFO_TOTAL`) +
                " _TOTAL_ " + t(`DATA_GRID.INFO_RECORDS`),
            no_data_text: t(`DATA_GRID.NO_RECORDS_FOUND`),
            pagination: {
                first: t(`DATA_GRID.BUTTON_FIRST`),
                previous: t(`DATA_GRID.BUTTON_PREVIOUS`),
                next: t(`DATA_GRID.BUTTON_NEXT`),
                last: t(`DATA_GRID.BUTTON_LAST`),
            },
        },
        sort: { column: "read_date", order: "desc" }
    }

    const setFilterDelete = async (currentTarget: any) => {

        let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dataset] };

        if (currentTarget.id !== null && requestParams?.datasets) 
        {

            let dataSet = requestParams.datasets[0];

            if (dataSet.filters.id_equipment_data_delete == null && currentTarget.checked)
            {
                setDataset({ ...dataset, filters: { ...dataset.filters, id_equipment_data_delete: [currentTarget.id] } })
                setNumberDeleted(1);
            }
            else if (currentTarget.checked)
            {
                let retfiltros  =  dataSet.filters.id_equipment_data_delete;
                retfiltros.push(currentTarget.id);
                setNumberDeleted(numberDeleted + 1);
            }
            else
            {

                let retfiltros  =  dataSet.filters.id_equipment_data_delete;
                var index = retfiltros.indexOf(currentTarget.id); 
                delete retfiltros[index];
                retfiltros = retfiltros.filter(element => element);
                setNumberDeleted(numberDeleted - 1);
            }
                
        }

    }

    const setFilterRestore = async (id: any) => {

        let newDataset = ({ ...dataset, filters: { ...dataset.filters, id_equipment_data_restore: [id] } })

        let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [newDataset] };

        
        
        const response: any = await EquipmentDataService.restoreByProc(requestParams);
        

        if (response.success && response.result) {
            getPaginatedList(null, true);
        } else {
            console.log('response error');
        }

        setLoading(false);

    }

    const getPaginatedList = async (dataTable: any, keepPagination: boolean = false) => {
        setLoading(true);
        let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dataset] };
        
        if (dataTable !== null && requestParams?.datasets) {

            let dataSet = requestParams.datasets[0];
            dataSet.sort.field = dataTable.sort_order.column;
            dataSet.sort.orientation = dataTable.sort_order.order;

            let pagination = dataSet.pagination;
            pagination.page_number = dataTable.page_number;
            pagination.records_pages = dataTable.page_size;      

        } else if (!keepPagination) {
            let pagination = requestParams.datasets[0].pagination;
            pagination.page_number = DatasetDefault.pagination.page_number;
            pagination.records_pages = DatasetDefault.pagination.records_pages;            
        }
        
        setNumberDeleted(0);
        const response: any = await EquipmentDataService.getPaginatedList(requestParams);

        

        if (response.success && response.result) {
            let dataSetModel: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'equipment_data' }));
            setData(dataSetModel);
        } else {
            console.log('response error');
        }

        setLoading(false);
    }

    const deleteByProc = async () => {
        setLoading(true);

        let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dataset] };
        let retfiltros  =  dataset.filters.id_equipment_data_delete;
        if ((retfiltros == null) || (numberDeleted == 0))
        {
            toast.warn(t('EQUIPMENT_HISTORY_MODAL.SELECT_LINE'), null);
            setLoading(false);
            return;
        }

        const response: any = await EquipmentDataService.deleteByProc(requestParams);

        

        if (response.success && response.result) {
            getPaginatedList(null, true);
        } else {
            console.log('response error');
        }

        setLoading(false);
    }

    const tableChangeHandler = async (data: any) => {
        await getPaginatedList(data);
    };

    const optionsFilter = [
        { value: '', label: 'Selecione' },
        { value: '1', label: '>' },
        { value: '2', label: '>='},
        { value: '3', label: '<' },
        { value: '4', label: '<='},
        { value: '5', label: '=' }
    ];


    // const [startDate, setStartDate] = useState(new Date().setDate(new Date().getDate() - 15))
    // const [endDate, setEndDate] = useState(new Date())
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)    
    const formatoData = user.locale.formatDate.replaceAll('DD', 'dd');
    const idiom = storageService.getIdiom();


    const handleSearch = async (event) => {
        
        setNumberDeleted(0);
        let tDataSet = { ...dataset, filters: { ...dataset.filters, filter_history: ['true'] } };
        if (startDate || endDate)
            tDataSet = { ...tDataSet, filters: { ...tDataSet.filters, date_begin_end: [startDate, endDate] } };
        if (operationVal)
            tDataSet = { ...tDataSet, filters: { ...tDataSet.filters, operator: [Number(operationVal.value)] } };
        if (balanceVal)
            tDataSet = { ...tDataSet, filters: { ...tDataSet.filters, balance: [UtilService.formatNumber(balanceVal)] } };

        event.preventDefault();
        setDataset(tDataSet);
        
      };

      useEffect(() => {
        if (numberDeleted == 0)
            getPaginatedList(null)
    }, [dataset]);
    
      const handleCleanFilter = () => {
        clear();  
      };

    useEffect(() => {
        if (props.show) {
            getPaginatedList(null);
        }
    }, [props.show]);

    return (
        <>
            <Modal size="lg" as={Modal.Dialog} centered show={props.show} onHide={close}>
                <Modal.Header>
                    <Modal.Title className='h6'>{props.title}</Modal.Title>
                    <Button variant='close' aria-label='Close' onClick={close} />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={4}>
                            <label>{t("DEPOSIT.READ_DATE")}</label>
                            <DatePicker
                                onChange={(date) => {
                                    const [ start, end] = date;

                                    const retstart = (start== null ? null:moment(start).format('YYYY-MM-DD'));
                                    const retend = (end== null ? null:moment(end).format('YYYY-MM-DD'));

                                    const dateret = [];
                                    dateret.push(retstart);
                                    dateret.push(retend);

                                    //setDataset({ ...dataset, filters: { ...dataset.filters, date_begin_end: dateret } });
                                    
                                    setStartDate(start);
                                    setEndDate(end);

                                }}
                                maxDate={moment().toDate()}
                                className={'form-control mr-3'}
                                selectsRange={true}
                                startDate={startDate}
                                endDate={endDate}
                                dateFormat={formatoData}
                                isClearable={true}
                                locale={idiom.replaceAll('-', '').trim()}
                            />  
                        </Col>

                        <Col sm={2}>                            
                            <label>{t("PROFILE.OPERATOR")}</label>
                            <Select 
                                max-width={5}
                                options={optionsFilter} 
                                defaultValue={{ value: '', label: 'Selecione'  }}
                                value={operationVal}
                                onChange={(e) => {
                                    setOperationVal(e);
                                    //setDataset({ ...dataset, filters: { ...dataset.filters, operator: [Number(e.value)] } })
                                }}                                
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                            />
                        </Col>
                        <Col sm={2}>
                        <label>{t("EQUIPMENT_HISTORY_MODAL.BALANCE")}</label>
                            <Form.Control
                                name='balance'
                                id='balance'
                                type='text'
                                defaultValue={0}
                                value={balanceVal}
                                placeholder={t(`EQUIPMENT_HISTORY_MODAL.BALANCE`)}
                                className='form-control'
                                onChange={(e) => {
                                    setBalanceVal(e.target.value.replace(/[^0-9,.]/,''));
                                    //setDataset({ ...dataset, filters: { ...dataset.filters, balance: [UtilService.formatNumber(e.target.value.replace(/\D/,''))] } })
                                }}
                            />
                        </Col>
                        <Col xs="auto">
                            <div style={{paddingTop: '20px'}}></div>
                            <ButtonSearch onClick={(e) => handleSearch(e)} isLoading={isLoading} /> &nbsp;&nbsp;&nbsp;
                            <ButtonClean onClick={async (e) => {e.preventDefault();handleCleanFilter();}} />

                        </Col>
                    </Row>
                    <ReactDatatable
                        config={localDataTableConfig}
                        records={data?.data ? data?.data : []}
                        columns={columns}
                        dynamic={true}
                        total_record={data?.pagination?.total_records ? data?.pagination?.total_records : 0}
                        onChange={tableChangeHandler}
                        className='table table-hover user-table align-items-center'
                        sort={{ column: "read_date", order: "desc" }}
                    />

                </Modal.Body>
                <Modal.Footer>

                    <DropdownButtonExport onClick={(type: string) =>
                        FileExportService.Export(
                            { ...RequestInputOutputParamsModelDefault, datasets: [dataset] },
                            "EquipmentData",
                            type
                        )}
                    /> 
                    <Col xs="auto">
                        <ButtonDelete 
                            onClick={async (e) => {e.preventDefault();deleteByProc()}} 
                            disabled={user.profile.profileName !== 'admin' && user.profile.profileName !== 'city_admin'}
                        />
                    </Col>
                    <Button
                        variant='link'
                        className='text-gray ms-auto'
                        onClick={close}>
                        {props.cancel}
                    </Button>

                </Modal.Footer>
            </Modal>
        </>
    );
}